import { css } from "@emotion/react";
import styled from "@emotion/styled";
import colors from "../../styles/colors";
import "../../index.scss";
export const Button = styled.button `
  font-family: Inter;
  font-weight: 700;
  border: 0;
  color: ${colors["color-white-100"]};
  border-radius: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  font-style: normal;
  font-weight: 600;
  font-size: 0.875rem;
  line-height: 1.25rem;
  gap: 0.375rem;

  ${(props) => getWidth(props.size, props.fullWidth)}
  ${(props) => getSize(props.size)}
  ${(props) => getBackgroundColor(props.$color)}
  ${(props) => props.variant == "outlined" ? getTheme(props.variant, props.border) : null};
  ${(props) => isRounded(props.rounded)}
`;
function isRounded(isRounded) {
    return isRounded
        ? css `
        border-radius: 2.5rem;
      `
        : null;
}
function getTheme(variant, border) {
    return css `
    border: 0.094rem solid ${colors[border]};
    border-radius: 0.5rem;
    &:hover:enabled {
      background-color: ${colors["color-blue-30"]};
    }
    &:active:enabled {
      border: 0.094rem solid ${colors["color-blue-160"]};
    }
    &:disabled {
      border: none;
    }
  `;
}
function getSize(size) {
    switch (size) {
        case "xx-small":
            return css `
        font-size: 0.563rem;
        line-height: 1.125rem;
        border-radius: 0.25rem;
      `;
        case "x-small":
            return css `
        font-size: 0.75rem;
        height: 2.375rem;
        line-height: 1.125rem;
      `;
        case "regular":
            return css `
        font-size: 0.875rem;
        padding: 1rem;
        height: 3.25rem;
      `;
        case "large":
            return css `
        font-size: 0.875rem;
        padding: 1rem;
        height: 3.25rem;
      `;
        case "x-large":
            return css `
        font-size: 0.875rem;
        padding: 1rem;
        height: 3.25rem;
      `;
        default:
            return css `
        font-size: 0.875rem;
        padding: 1rem;
        height: 3.25rem;
      `;
    }
}
function getWidth(size, fullWidth) {
    if (fullWidth) {
        return css `
      width: 100%;
    `;
    }
    switch (size) {
        case "xx-small":
            return css `
        width: 2.375rem;
        border-radius: 0.25rem;
      `;
        case "x-small":
            return css `
        width: 8.75rem;
      `;
        case "regular":
            return css `
        width: 9.375rem;
      `;
        case "large":
            return css `
        width: 12.5rem;
      `;
        case "x-large":
            return css `
        width: 15.625rem;
      `;
    }
}
function getBackgroundColor(color) {
    switch (color) {
        case "primary":
            return css `
        background-color: ${colors["color-blue-120"]};
        color: ${colors["color-white-100"]};
        &:hover:enabled {
          background-color: ${colors["color-blue-90"]};
        }
        &:active:enabled {
          background-color: ${colors["color-blue-160"]};
        }
        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
        }
        &:focus-visible {
          background-color: ${colors["color-blue-160"]};
          color: ${colors["color-white-100"]};
          border: 0.063rem solid ${colors["color-white-100"]};
          box-shadow: 0px 0px 0px 3px ${colors["color-blue-70"]};
        }
      `;
        case "secondary":
            return css `
        background-color: ${colors["color-white-100"]};
        color: ${colors["color-blue-120"]};
        &:hover:enabled {
          background-color: ${colors["color-blue-30"]};
        }
        &:active:enabled {
          background-color: ${colors["color-blue-160-20p"]};
        }
        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
        }
        &:focus-visible {
          background-color: ${colors["color-blue-30"]};
          color: ${colors["color-blue-160"]};
          border: 0.094rem solid ${colors["color-blue-160"]};
          box-shadow: 0px 0px 0px 3px ${colors["color-blue-70"]};
        }
      `;
        case "ghost":
            return css `
        background-color: ${colors["color-gray-20"]};
        color: ${colors["color-blue-120"]};
        font-size: 0.875rem;
        line-height: 1.313rem;
        width: 6.25rem;
        gap: 0.625rem;

        &:hover:enabled {
          background-color: ${colors["color-gray-30"]};
        }
        &:active:enabled {
          background-color: ${colors["color-gray-40"]};
        }
        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
        }
        &:focus-visible {
          background-color: ${colors["color-blue-30"]};
          color: ${colors["color-blue-160"]};
          border: 0.094rem solid ${colors["color-blue-160"]};
        }
      `;
        case "tertiary":
            return css `
        background-color: ${colors["color-gray-30"]};
        color: ${colors["color-blue-120"]};
        &:hover:enabled {
          background-color: ${colors["color-blue-30"]};
          color: ${colors["color-blue-100"]};
        }
        &:active:enabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-blue-160"]};
        }
        &:disabled {
          background-color: ${colors["color-gray-40"]};
          color: ${colors["color-gray-110"]};
          border: 0.063rem solid ${colors["color-gray-110"]};
        }
        &:focus-visible {
          background-color: ${colors["color-gray-30"]};
          color: ${colors["color-blue-160"]};
          border: 0.063rem solid ${colors["color-blue-160"]};
          box-shadow: 0px 0px 0px 3px ${colors["color-blue-70"]};
        }
      `;
        case "none":
            return css `
        background-color: transparent;
        color: ${colors["color-blue-120"]};
        justify-content: flex-start;
        width: 100%;

        &:hover:enabled {
          color: ${colors["color-blue-100"]};
        }
        &:active:enabled {
          color: ${colors["color-blue-160"]};
        }
        &:disabled {
          color: ${colors["color-gray-100"]};
        }
        &:focus-visible {
          color: ${colors["color-gray-160"]};
          border: 0.063rem solid ${colors["color-blue-160"]};
        }
      `;
    }
}
//# sourceMappingURL=Button.styled.js.map